import React from "react";
import { GitCompare, X } from "lucide-react";
import { SITE_CONTAINER } from "@/lib/siteLayout";

export const CompareBar = ({ compareList, onClear, onRemove, onOpen }) => {
  if (compareList.length === 0) return null;

  return (
    <div
      data-testid="compare-bar"
      className="fixed bottom-0 left-0 right-0 z-40 pb-4 pointer-events-none"
    >
      <div className={`${SITE_CONTAINER} pointer-events-auto`}>
        <div className="glass-strong rounded-2xl p-4 flex items-center gap-4 shadow-2xl">
          <div className="flex items-center gap-2 text-electric">
            <GitCompare className="w-5 h-5" strokeWidth={1.5} />
            <span className="text-sm font-medium hidden sm:inline">Összehasonlítás</span>
          </div>

          <div className="flex-1 flex items-center gap-2 overflow-x-auto">
            {compareList.map((car) => (
              <div
                key={car.id}
                className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 whitespace-nowrap"
              >
                <span className="text-xs text-slate-200">{car.make} {car.model}</span>
                <button
                  data-testid={`compare-remove-${car.id}`}
                  onClick={() => onRemove(car)}
                  className="text-slate-400 hover:text-white"
                >
                  <X className="w-3.5 h-3.5" />
                </button>
              </div>
            ))}
          </div>

          <button
            data-testid="compare-clear"
            onClick={onClear}
            className="text-xs text-slate-400 hover:text-white hidden sm:inline"
          >
            Törlés
          </button>

          <button
            data-testid="compare-open"
            onClick={onOpen}
            disabled={compareList.length < 2}
            className="px-5 py-2.5 rounded-full bg-electric hover:bg-electric-light disabled:opacity-40 disabled:cursor-not-allowed text-white text-sm font-medium transition-all whitespace-nowrap"
          >
            Összehasonlítás ({compareList.length})
          </button>
        </div>
      </div>
    </div>
  );
};
